// extracted by mini-css-extract-plugin
export var audioPlayer = "_qv-0";